function initMenu() {

    const menuTrigger   =  document.querySelector('.toggle-menu');

    const menu              = document.querySelector('#main-menu-holder');
    const closeTrigger      = menu.querySelector('.close-menu');

    const menuMainContentHolder  = document.querySelector('#menu-content-holder');


    gsap.set(menuMainContentHolder, {y: -50,transformOrigin: '0% 0%'});


    menuTrigger.addEventListener("click", openMenu);
    closeTrigger.addEventListener("click", closeMenu);

    function openMenu(e){

        if(e) e.preventDefault();

        document.body.classList.add('overflow-hidden');
        //menu.style.display = 'block';
        gsap.to(menu, {ease: Power1.easeOut, y: 0,  duration: 0.6, onComplete(){
        }});
        setTimeout(function(){ 
            gsap.to(menuMainContentHolder, {ease: Power1.easeIn, y: 0,  duration: 0.6, onComplete(){

            }});

        },100);

    }

    function closeMenu(e){

        if(e) e.preventDefault();
        //logo.classList.remove('bar')

       gsap.to(menuMainContentHolder, {ease: Power1.easeOut, y: -100,  duration: 0.5, onComplete(){

       }});

        setTimeout(function(){

             gsap.to(menu, {ease: Power1.easeIn, y: '-100%',  duration: 0.5, onComplete(){


                    document.body.classList.remove('overflow-hidden');


            }});

        },50);


    }

    return {

        openMenu:  openMenu,
        closeMenu: closeMenu
    }
}
